import { createSlice } from "@reduxjs/toolkit";
import { getRfpRequests } from "../../../thunks/seller-thunks/SellerThunk";
import {
  downloadRFPSearchCriteria,
  requestExternalSearch,
} from "../../../thunks/buyer-thunks/BuyerThunks";
import { message } from "antd";

const initialState = {
  isLoading: false,
  error: null,
  rfpExternalSearch: null,
  rfpPdf: null,
  // if you have a status, you can store "idle", "loading", "success", "failed"
};

export const rfpSlice = createSlice({
  name: "rfp",
  initialState,
  reducers: {
    clearRfpPdf: (state) => {
      state.rfpPdf = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getRfpRequests.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getRfpRequests.fulfilled, (state, action) => {
        state.isLoading = false;
        state.rfpList = action.payload;
      })
      .addCase(getRfpRequests.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        message.error("Something went wrong!");
      });

    builder
      .addCase(requestExternalSearch.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(requestExternalSearch.fulfilled, (state, action) => {
        state.isLoading = false;
        state.rfpExternalSearch = action.payload.message;
        message.success(action.payload.message);
      })
      .addCase(requestExternalSearch.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        message.error("Something went wrong!");
      });
    builder
      .addCase(downloadRFPSearchCriteria.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(downloadRFPSearchCriteria.fulfilled, (state, action) => {
        state.isLoading = false;
        state.rfpPdf = action.payload;
      })
      .addCase(downloadRFPSearchCriteria.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        message.error("Something went wrong!");
      });
  },
});

export default rfpSlice.reducer;
export const { clearRfpPdf } = rfpSlice.actions;
